 

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface PayersParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface Payers {
    id?: number;
    payerName: string;
    referenceNum: string
    type: string
   // typeName:string
    officeAddress:string
    officeWorkphone:string
    officeEmail:string
    licenceNum?:string
    contactName:string
    contactMobile:string
    altMobile?:string
    officeWebsite?:string
    contactEmail?:string
    creditDays?:string
    tax?:string
    settlementCategory:string,
    tds:number;
    activeFlag?:string
    BillMode?:string;
    tpaFlag:string;
    tenantId?: string;
    brandId?: string;
    parameters?: PayersParameter[];
    links?: any;
    separateCostPrice?:any;
    ownershipType?:string;
}
export interface TypeOptions {
  value: number;
  title: string;
}
export interface PayerCheckList { 
  id?:number;
 type:string;
 checkListName:string;
 mandatoryFlag:string;
 activeFlag:string;
 approveRequiredFlag:string;
 updatedDate:Date;
 createdDate:Date;
 tenantId: string;
 branchId: string;
 updatedBy:number;
 createdBy:number;
 checklistHeader?:string;
 rowId?:Number;
 
}

export abstract class PayersData {
  //abstract fireRequest(data: Department, method: string): Observable<any>;
  abstract list(url: string): Observable<any[]>;
  abstract create(url: string,data: any): Observable<any>;
  // abstract search(url: string,data: any): Observable<any>;
  abstract update(url: string,data: any): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
